import { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config";

// Master switch for the whole Mango section (nav links, /mango route) -
// separate from an individual variety's own `available` flag, which only
// matters once you're already on the page. Defaults to true (shown) so a
// slow/failed settings fetch never hides a feature that should be there.
export const useShowMango = () => {
  const [showMango, setShowMango] = useState(true);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API_BASE_URL}/settings`)
      .then((response) => {
        if (!cancelled && typeof response.data?.settings?.showMango === "boolean") {
          setShowMango(response.data.settings.showMango);
        }
      })
      .catch((error) => console.error("Error fetching showMango setting:", error));
    return () => {
      cancelled = true;
    };
  }, []);

  return showMango;
};
